import actionTypes from './actionTypes.js';
import namespace from './namespace';
export function GetIsBottom(data) {
  return {
    type: namespace + '/' + actionTypes.GET_ISBOTTOM,
    data
  };
}